/**
 * @generated SignedSource<<96b1c38b1685350a239c3c284f1f33b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ImageBlock_content$data = {
  readonly id: string;
  readonly image: {
    readonly data: {
      readonly attributes: {
        readonly alternativeText: string | null;
        readonly formats: any | null;
        readonly height: number | null;
        readonly name: string;
        readonly placeholder: string | null;
        readonly url: string;
        readonly width: number | null;
      } | null;
    } | null;
  };
  readonly imageTitle: string | null;
  readonly " $fragmentType": "ImageBlock_content";
};
export type ImageBlock_content$key = {
  readonly " $data"?: ImageBlock_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"ImageBlock_content">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ImageBlock_content",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": "image",
      "args": null,
      "concreteType": "UploadFileEntityResponse",
      "kind": "LinkedField",
      "name": "Image",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UploadFileEntity",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UploadFile",
              "kind": "LinkedField",
              "name": "attributes",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "placeholder",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "alternativeText",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "height",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "width",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "formats",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "imageTitle",
      "args": null,
      "kind": "ScalarField",
      "name": "Title",
      "storageKey": null
    }
  ],
  "type": "ComponentContentImage",
  "abstractKey": null
};

(node as any).hash = "325dd4945684298bbd59f6fb8f789e5b";

export default node;
